(function() {
  var storageKey = 'gibbon_alia_discount_code';
  var activeRequest = null;

  function normalizeCode(code) {
    return typeof code === 'string' ? code.trim().slice(0, 255) : '';
  }

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + path;
  }

  function readStoredCode() {
    try {
      return normalizeCode(window.sessionStorage.getItem(storageKey));
    } catch (error) {
      return '';
    }
  }

  function storeCode(code) {
    try {
      window.sessionStorage.setItem(storageKey, code);
    } catch (error) {}
  }

  function clearStoredCode() {
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {}
  }

  function appliedDiscountCodes(cart) {
    return (cart.discount_applications || [])
      .filter(function(discount) {
        return discount && discount.type === 'discount_code';
      })
      .map(function(discount) {
        return normalizeCode(discount.title);
      })
      .filter(Boolean);
  }

  function includesCode(codes, code) {
    var normalized = code.toLowerCase();
    return codes.some(function(existingCode) {
      return existingCode.toLowerCase() === normalized;
    });
  }

  function uniqueCodes(codes) {
    var seen = {};
    return codes.filter(function(code) {
      var key = code.toLowerCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart }
    }));
  }

  function applyDiscountCode(rawCode) {
    var code = normalizeCode(rawCode);
    if (!code) return Promise.resolve(null);
    if (activeRequest) return activeRequest;

    activeRequest = fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to read the cart.');
        return response.json();
      })
      .then(function(cart) {
        var existingCodes = appliedDiscountCodes(cart);
        if (includesCode(existingCodes, code)) {
          storeCode(code);
          return cart;
        }

        var codes = uniqueCodes(existingCodes.concat(code));
        return fetch(cartUrl('cart/update.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ discount: codes.join(',') })
        }).then(function(response) {
          if (!response.ok) throw new Error('Unable to apply the Alia discount.');
          return response.json();
        });
      })
      .then(function(cart) {
        if (!includesCode(appliedDiscountCodes(cart), code)) {
          clearStoredCode();
          throw new Error('The Alia discount was not accepted by Shopify.');
        }

        storeCode(code);
        notifyCartUpdated(cart);
        return cart;
      })
      .catch(function(error) {
        if (window.console && console.warn) {
          console.warn('[Alia cart discount]', error.message || error);
        }
        return null;
      })
      .then(function(result) {
        activeRequest = null;
        return result;
      });

    return activeRequest;
  }

  document.addEventListener('alia:rewardClaimed', function(event) {
    var detail = event && event.detail ? event.detail : {};
    applyDiscountCode(detail.discountCode || detail.code || detail.couponCode);
  });

  document.addEventListener('cart:open', function() {
    var storedCode = readStoredCode();
    if (storedCode) applyDiscountCode(storedCode);
  });
})();
